import { string, number, object } from 'prop-types'
import { Asset } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { baseStyles } from './styles'

export const ContentAvatar = ({
  assetReference,
  borderRadius = '50%',
  size = 32,
  style,
}) => {
  if (assetReference) {
    const scaledDimension = size * 2
    return (
      <div
        className={kuiperClassNames('content-avatar')}
        css={baseStyles({ borderRadius, size, style, assetReference })}
      >
        <Asset
          assetReference={assetReference}
          preview={true}
          transforms={{ width: scaledDimension, height: scaledDimension }}
        />
      </div>
    )
  }

  return (
    <div
      css={baseStyles({ borderRadius, size, style, assetReference })}
      className={kuiperClassNames('content-avatar')}
    />
  )
}

ContentAvatar.propTypes = {
  assetReference: object,
  borderRadius: string,
  size: number,
  style: object,
}
